import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { MediatorService } from './mediator/mediator.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./mediator/mediator.service";
var AppsService = /** @class */ (function () {
    function AppsService(http, mediatorService) {
        this.http = http;
        this.mediatorService = mediatorService;
        this.userComopanies = null;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    AppsService.prototype.changeAppStatus = function (appId, newState) {
        var url = '/dashboard/changeappstatus';
        var body = {
            app_id: appId,
            to_state: newState
        };
        return this.http.post(url, body).pipe(map(function (res) {
            var responseBody = res;
            return responseBody || {};
        }));
    };
    AppsService.prototype.fakeResponse = function (dataName) {
        return of((new HttpResponse({ status: 200, body: dataName })).body);
    };
    AppsService.prototype.getAppsDetailsCount = function (cb) {
        this.getAppCount().subscribe(function (data) {
            cb && cb(data);
        });
    };
    AppsService.prototype.getAppCount = function () {
        var _this = this;
        var url = '/dashboard/getappcounts';
        return _this.http.get(url).pipe(map(function (res) {
            var body = res;
            var failureData = {
                'is_error': false,
                'api_response': {
                    'app_wise_count': {}
                }
            };
            if (!body || body.is_error) {
                return failureData;
            }
            return body;
        }));
    };
    AppsService.prototype.getAllApps = function () {
        var _this_1 = this;
        var endpoint = '/dashboard/getusercompanies?dashboard_version=3.0';
        var _this = this;
        return new Observable(function (observer) {
            if (_this_1.userComopanies) {
                observer.next(_this_1.userComopanies);
                return;
            }
            _this.http.get(endpoint, tslib_1.__assign({}, _this.httpOptions)).subscribe(function (res) {
                return _this.mediatorService.getObservable('stage_apps', 'enabled').subscribe(function (flag) {
                    if (res.is_error) {
                        _this_1.userComopanies = null;
                        observer.next(res);
                        return res;
                    }
                    var companyData = res.api_response.companies[0];
                    if (flag) {
                        companyData.apps.forEach(function (app) {
                            if (app.env === 'stage') {
                                app.env = 'production';
                                app.name = 'stage-' + app.name;
                            }
                        });
                    }
                    // Remove company level crap
                    res.api_response.apps = companyData.apps;
                    // Okay maybe not, VJ needs it
                    res.api_response.company_details = {
                        email: companyData.email,
                        id: companyData.id,
                        name: companyData.name,
                        workflow_enabled: companyData.workflow_enabled,
                        ts: companyData.ts,
                        max_live_app_count: companyData.max_live_app_count
                    };
                    delete res.api_response.companies;
                    _this_1.userComopanies = res;
                    observer.next(res);
                });
            });
        });
    };
    AppsService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    AppsService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            // TODO: better job of transforming error for user consumption
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    AppsService.ngInjectableDef = i0.defineInjectable({ factory: function AppsService_Factory() { return new AppsService(i0.inject(i1.HttpClient), i0.inject(i2.MediatorService)); }, token: AppsService, providedIn: "root" });
    return AppsService;
}());
export { AppsService };
